<template>
	<div>
		<div class="list-btn">
			
			<Button type="primary" @click="ret">返回</Button>
			
			 
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				 
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '描述',
						key: 'typeExplain'
					},
					{
						title: '抽成比例',
						key: 'rake',
						
						render: (h, params) => {
							return h("div",params.row.rake/10000)
						}
						
					},
					{
						title: '状态',
						key: 'state',
						render: (h, params) => {
							if(params.row.state==true){
								return h("div","启用")
							}else{
								return h("div","禁用")
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10,
					level:2,
					parentId:1
				}

			}
		},
		methods: {
			
				ret() {//返回上一页
					this.$router.go(-1)
				},
			
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.query.parentId = this.$route.query.id
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/type/list2.vue